import { datePicker } from './datePicker.js';

var repeater = {
  options: {
    // global options
  },

  selectors: {
    "exception_box": ".js-repeater",
    "button_add_new_row": ".js-repeater-add-new-item",
    "items": ".js-repeater-items",
    "item": ".js-repeater-item",
    "button_delete_item": ".js-repeater-delete-item",
  },

  init: function () {
    const self = this;

    jQuery(self.selectors.exception_box + " label input[type='checkbox']").on("input", function () {
      const jquery_exception_box = jQuery(this).closest(self.selectors.exception_box);

      if (jQuery(this).prop("checked")) {
        jquery_exception_box.addClass("open");

        if (jquery_exception_box.find(self.selectors.items).children().length === 1) self.addNewItem(jquery_exception_box); //add one new item
      } else {
        jquery_exception_box.removeClass("open");
      }
    });

    jQuery(self.selectors.exception_box).not(jQuery(self.selectors.exception_box).has("label input[type='checkbox']")).each(function() {
      jQuery(this).addClass("open");

      if (jQuery(this).find(self.selectors.items).children().length === 1) self.addNewItem(jQuery(this)); //add one new item
    });

    jQuery(self.selectors.button_add_new_row).on("click", function (event) {
      event.preventDefault();
      self.addNewItem(jQuery(this).closest(self.selectors.exception_box));
    });

    //init
    jQuery(self.selectors.button_delete_item).one("click", function (event) {
      event.preventDefault();
      self.deleteItem(jQuery(this).closest(self.selectors.item));
    });

    //init date picker
    const date_from = jQuery(self.selectors.exception_box).find(".js-type-daterange-from");
    const date_to = jQuery(self.selectors.exception_box).find(".js-type-daterange-to");

    if (date_from.length > 0 && date_to.length > 0) {
      datePicker.createDateRangePicker(date_from, date_to);
    }
  },

  addNewItem: function (jquery_exception_box) {
    const self = this;

    const default_item = jquery_exception_box.find(".default").prop('outerHTML');
    jquery_exception_box.find(self.selectors.items).append(default_item);
    const new_item = jquery_exception_box.find(self.selectors.items).children().last();

    //delete button
    jquery_exception_box.find(self.selectors.button_delete_item).one("click", function (event) {
      event.preventDefault();
      self.deleteItem(jQuery(this).closest(self.selectors.item));
    });

    //date picker
    const date_from = new_item.find(".js-type-daterange-from");
    const date_to = new_item.find(".js-type-daterange-to");

    if (date_from.length > 0 && date_to.length > 0) {
      datePicker.createDateRangePicker(date_from, date_to);
    }
  },

  deleteItem: function (jquery_item) {
    const self = this;
    jquery_item.remove();
  },
}

// Export
export { repeater };